var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseButtonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2414"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 412",
    cx: 32.5,
    cy: 32.439,
    r: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 2410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 42",
    d: "M23.5 23.439L42.5 42.439",
    stroke: "#F54B4B",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 43",
    d: "M42.5 23.439L23.5 42.439",
    stroke: "#F54B4B",
    strokeWidth: 4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButtonIcon);
export default __webpack_public_path__ + "static/media/close-button-icon.fafefa32f849ec9328fe07a0cb20e08d.svg";
export { ForwardRef as ReactComponent };